// 获取assets中的资源
export function _import(name) {
	return require(`@/assets/${name}`);
}

/**
 * 日期格式化
 */
export function formatDate(cellValue, format) {
	if (cellValue == null || cellValue == "") return "";
	let date = new Date(cellValue);
	let str = "";

	if(format === "date") {
		str = "yyyy-MM-dd";
	}else if(format === "time") {
		str = "HH:mm:ss";
	}else if(format === "dateTime" || !format) {
		str = "yyyy-MM-dd HH:mm:ss";
	}else {
		str = format;
	}

	if( str.includes("yyyy") ) str = str.replace( "yyyy", ( date.getFullYear() + "" ).padStart(4, "0") );
	if( str.includes("MM") ) str = str.replace( "MM", ( date.getMonth() + 1 + "" ).padStart(2, "0") );
	if( str.includes("dd") ) str = str.replace( "dd", ( date.getDate() + "" ).padStart(2, "0") );
	if( str.includes("HH") ) str = str.replace( "HH", ( date.getHours() + "" ).padStart(2, "0") );
	if( str.includes("mm") ) str = str.replace( "mm", ( date.getMinutes() + "" ).padStart(2, "0") );
	if( str.includes("ss") ) str = str.replace( "ss", ( date.getSeconds() + "" ).padStart(2, "0") );
	return str
}

/**
 * 时间字符串格式化
 * 20181224235959
 */
export function formatDateStr(str) {
	if(!str) str = "99991231235959";
	str = (str+"").padEnd(14, "9");
	let yyyy = str.substr(0, 4);
	let MM = str.substr(4, 2);
	let dd = str.substr(6, 2);
	let HH = str.substr(8, 2);
	let mm = str.substr(10, 2);
	let ss = str.substr(12, 2);
	return yyyy + "-" + MM + "-" + dd + " " + HH + ":" + mm + ":" + ss
}

/**
 * base64格式转文件流
 * @param base64Str base64
 * @param filename 文件名称
 */
export function base64toFile(base64Str, filename = 'file') {
	let arr = base64Str.split(',')
	let mime = arr[0].match(/:(.*?);/)[1]
	let suffix = mime.split('/')[1]
	let bstr = atob(arr[1])
	let n = bstr.length
	let u8arr = new Uint8Array(n)
	while (n--) {
		u8arr[n] = bstr.charCodeAt(n)
	}
	return new File([u8arr], `${filename}.${suffix}`, {
		type: mime
	})
}

/**
 * 通用文件下载
 * @param url 文件地址
 * @param name 文件名称 默认取文件地址中的名称
 */
export async function downloadFile(url, name) {
	let res = await fetch(url);
	let blob = await res.blob();
	let objUrl = window.URL.createObjectURL(blob);
	let a = document.createElement("a");
	a.href = objUrl;
	a.download = name ? name : url.substr( url.lastIndexOf('/') === -1 ? 0 : url.lastIndexOf('/') + 1 );
	a.click();
	a.remove();
}

// 回显数据字典
export function getDictLabel(datas, value) {
	if (value === undefined) {
		return "";
	}
	let actions = [];
	Object.keys(datas).some((key) => {
		if (datas[key].dictValue == ('' + value)) {
			actions.push(datas[key].dictLabel);
			return true;
		}
	})
	if (actions.length === 0) {
		actions.push(value);
	}
	return actions.join('');
}

